import { TranslationKeyTranslation } from '../../../models/translation';
import { WeekDayEnum } from '../../../models/weekday.enum';

export const translationsEn: TranslationKeyTranslation = {
  yes: 'Yes',
  no: 'No',
  all: 'All',
  job: 'Job',
  jobSeries: 'Job Series',
  jobRequest: 'Job Request',
  german: 'German',
  english: 'English',
  french: 'French',
  created: 'Created',
  updated: 'Updated',
  status: 'Status',
  loadAll: 'Load All',
  loadMore: 'Load More',
  download: 'Download',
  cancelItem: 'Cancel',
  externalCancellations: 'External Cancellations',
  duplicate: 'Duplicate',
  summary: 'Summary',
  clearSelection: 'Clear Selection',
  fieldRequiredError: 'Please fill out this required field',
  overlappingTrackings: 'Please correct overlapping shifts',
  badTimeSpan: 'From and To times cannot be the same',
  pauseTooBig: 'Break time cannot be greater than working time',
  submit: 'Submit',
  name: 'Name',
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email',
  sms: 'SMS',
  phone: 'Phone',
  password: 'Password',
  setPassword: 'Set Password',
  resetPassword: 'Reset Password',
  forgotPassword: 'Forgot Password?',
  newPassword: 'New Password',
  repeatPassword: 'Repeat Password',
  passwordDoesntMatch: 'Passwords do not match',
  passwordIsToShort: 'Password is too short.',
  required: 'Required',
  inputDoesNotMatch: 'Input does not match',
  login: 'Login',
  loading: 'Loading...',
  loggingIn: 'Logging in...',
  reset: 'Reset',
  goToLogin: 'Go to Login',
  add: 'Add',
  cancel: 'Cancel',
  back: 'Back',
  search: 'Search...',
  sex: 'Sex',
  maleSex: 'Male',
  femaleSex: 'Female',
  otherSex: 'Other',
  salutation: 'Salutation',
  mr: 'Mr',
  mrs: 'Ms',
  date: 'Date',
  weekday: 'Weekday',
  timeOfDay: 'Time',
  cancelTime: 'Cancel Time',
  dateFrom: 'Date From',
  dateTo: 'Date To',
  startDate: 'Start Date',
  endDate: 'End Date',
  startTime: 'Start Time',
  endTime: 'End Time',
  bookedAt: 'Gebucht am',
  total: 'Total',
  employees: 'Employees',
  employee: 'Employee',
  save: 'Save',
  edit: 'Edit',
  remove: 'Remove',
  details: 'Details',
  welcome: 'Welcome',
  state: 'Status',
  confirm: 'Confirm',
  description: 'Description',
  close: 'Close',
  hide: 'Hide',
  filter: 'Filter',
  decline: 'Decline',
  moreOptions: 'More Options',
  transfer: 'Transfer',
  transcribe: 'Transfer',
  done: 'Done',
  toComplete: 'Mark as Done',
  areYouSure: 'Are you sure?',
  areYouSurePolite: 'Are you sure?',
  unsavedChangesTitle: 'Unsaved Changes',
  unsavedChangesText:
    'You have unsaved changes. Do you really want to continue?',
  pleaseEnterName: 'Please enter your full name.',
  orderId: 'Order ID',
  branch: 'Branch',
  create: 'Create',
  new: 'New',
  from: 'From',
  to: 'To',
  pause: 'Pause',
  selectDateRange: 'Select Date Range',
  noUsersFound: 'No employees found',
  showAll: 'Show All',
  showLess: 'Show Less',
  or: 'or',
  editor: 'Editor',
  creator: 'Creator',
  availabilities: 'Availabilities',
  jobAvailabilities: 'Job Availabilities',
  employmentAvailabilities: 'Employment Availabilities',
  organisationAndDepartment: 'Organization, Department',
  timespan: 'Timespan',
  now: 'Now',
  request: 'Request',
  availabilitiesNoUmlaut: 'Availabilities',
  availabilitiesTemporary: 'Temporary Availabilities',
  availability: 'Availability',
  label: 'Label',
  notificationType: 'Notification Type',
  weekdays: {
    [WeekDayEnum.MONDAY]: 'Monday',
    [WeekDayEnum.TUESDAY]: 'Tuesday',
    [WeekDayEnum.WEDNESDAY]: 'Wednesday',
    [WeekDayEnum.THURSDAY]: 'Thursday',
    [WeekDayEnum.FRIDAY]: 'Friday',
    [WeekDayEnum.SATURDAY]: 'Saturday',
    [WeekDayEnum.SUNDAY]: 'Sunday',
  },
  carLicenseEnum: {
    '0': "Driver's license available",
    '1': "Car and driver's license available",
  },
  languageEnum: {
    '0': 'German',
    '1': 'English',
    '2': 'Italian',
    '3': 'French',
  },
  poolerType: 'Employment Type',
  mobility: 'Mobility',
  languages: 'Languages',
  language: 'Language',
  systemLanguage: 'System Language',
  departments: 'Departments',
  department: 'Department',
  clinic: 'Clinic',
  section: 'Section',
  all_departments: 'All Departments',
  available: 'Available',
  unavailable: 'Unavailable',
  booked: 'Booked',
  shift: 'Shift',
  shiftPlural: 'Shifts',
  shiftNotAvailableOnDepartment: 'Shift not available at this department',
  customer: 'Customer',
  agency: 'Agency',
  offerFrom: 'Offer from',
  all_agencies: 'All Agencies',
  verify: 'Verify',
  twoFa: 'Two-Factor Authentication',
  resendAuthCode: 'Resend Code',
  authCodeSentTo: 'We sent you a confirmation code to',
  authCodeSentToYourPhone: 'your phone. Please enter the code here.',
  codeInvalidOrExpired: 'Code is invalid or expired',
  requiredField: 'Required Field',
  emailInvalid: 'Invalid email',
  phoneConfirmation: 'Phone Confirmation',
  noPoolerFound: 'No pooler found',
  phoneNumber: 'Phone Number',
  emailAddress: 'E-Mail Address',
  additionalInfo: 'Additional Information',
  additionalAvailabilityInfo: 'Additional Availability Information',
  additionalAvailabilityInfoPlaceholder: 'e.g., available only until 10:00 PM',
  statusEnum: {
    '0': 'Open',
    '1': 'Archived',
    '2': 'Closed',
    '3': 'Declined',
    '4': 'Available',
    '5': 'Unavailable',
    '6': 'Booked',
    '7': 'Requested',
    '8': 'Not Available',
    '9': 'Canceled',
    '10': 'In Progress',
    '11': 'Pool Removed',
    '12': 'Available',
    '13': 'Possible Candidate',
  },
  jobStatusEnum: {
    OPEN: 'Open',
    ARCHIVED: 'Archived',
    CLOSED: 'Closed',
    CANCELED: 'Canceled',
    JOB_REQUESTED: 'Requested',
  },
  inviteeStatusEnum: {
    OPEN: 'Open',
    DECLINED: 'Declined',
    AVAILABLE: 'Available',
    UNAVAILABLE: 'Unavailable',
    BOOKED: 'Booked',
    CANCELED: 'Canceled',
    WORKING: 'Working',
    POSSIBLE_CANDIDATE: 'Possible Candidate',
    TRANSFERRED: 'Transferred',
    PARTIAL_AVAILABLE: 'Partial Available',
  },
  customerUserStatusEnum: {
    REQUESTED: 'Requested',
    INEXISTENT: 'Inexistent',
    POOL_REMOVED: 'Pool Removed',
    EXISTENT: 'Existent',
  },
  submitted: 'Submitted',
  bookedBy: 'Booked by',
  bookedIn: 'Booked in',
  availabilityOverviewBookedCounts: 'Booked in this station / Total booked',
  perPooler: 'per pooler',
  perDepartment: 'per department',
  perOrganisation: 'per organization',
  organisations: 'Organizations',
  organisation: 'Organization',
  addTag: 'Add Tag',
  originalCertificates: 'Original Certificates',
  originalSpecialities: 'Original Specialties',
  originalSex: 'Original Gender',
  originalCar: 'Original Mobility',
  originalLanguage: 'Original Language',
  originally: 'Originally',
  empty: 'empty',
  createLink: 'Create Link',
  hours: 'Hours',
  toAdd: 'hours to record',
  toApprove: 'to approve',
  approved: 'approved',
  inviteeTransferReason: 'Reason for rescheduling',
  transferInviteTarget: 'Transfer destination',
  transferCreateNewJob: 'New Job',
  disabledBecauseExternalTransfer:
    'Criteria adjustment is disabled because the service has been transferred to external agencies. Qualifications can only be added, not removed.',
  createNewTag: 'Create New Tag',
  reports: 'Reports',
  informInviteeOfReason: 'Inform employee of the reason',
  selectAllDepartments: 'Select All Visible Departments',
  deselectAllDepartments: 'Deselect All Visible Departments',
  allDepartments: 'All Departments',
  areYouSureSelectAllDepartments:
    'Are you sure you want to select all visible departments?',
  areYouSureDeselectAllDepartments:
    'Are you sure you want to deselect all visible departments?',
  approvedAt: 'Approved at',
  approvedBy: 'Approved by',
  timeTracking: 'Time Tracking',
  disableTimeTracking: 'Disable Time Tracking',
  disableTimeTrackingDescription:
    'Disabling time tracking will prevent the recording of hours and delete any outstanding time recordings.',
  enableTimeTracking: 'Enable Time Tracking',
  enableTimeTrackingDescription:
    'Enabling time tracking will apply to all future created services, but not to already recorded services.',
  jobType: 'Service Type',
  jobTypeEnum: {
    '1': 'Normal',
    '2': 'Sitting Watch',
    '3': '1 to 1',
  },
  demandReason: 'Demand Reason',
  demandReasonEnum: {
    WORKLOAD: 'Workload / Elaborate care',
    LACK_OF_STAFF: 'Lack of staff / Open position ',
    ACCIDENT: 'Accident',
    SICKNESS: 'Sickness',
    ONE_ON_ONE: '1:1 Care',
    PATIENT_SITTING: 'Patient sitting',
    OTHER: 'Other reason',
  },
  cancelCostWarningTitle: 'Possible Cancellation Costs',
  cancelCostWarningMessage:
    'You are canceling a person within the cost-effective cancellation period. If you have any questions, please contact your broker. \n Do you still want to continue?',
  maleGreeting: 'Dear',
  femaleGreeting: 'Dear',
  neutralGreeting: 'Hello',
  sincerely: 'Best regards',
  noReplyMessage:
    'This is an automatically generated email. Please do not reply.',
  buttonNotWorking: 'Is the button not working?',
  requestType: 'Request Type',
  endpoint: 'Endpoint',
  requestBody: 'Request Body',
  errorMessage: 'Error Message',
  key: 'Field',
  newValue: 'New Value',
  oldValue: 'Old Value',
  jobPool: 'Job Pool',
  employmentPool: 'Temporary Pool',
  calendarWeekShort: 'CW',
  employmentDuration: 'Assignment Duration',
  newEmployment: 'New Assignment',
  declined: 'Declined',
  address: 'Address',
  departmentPhone: 'Department Phone',
  workload: 'Workload',
  workloadInPercent: 'Workload in %',
  newVersionTitle: 'New Version Available',
  newVersionText: 'Please reload the page to use the latest version.',
  reload: 'Reload',
  declineReasonEnum: {
    CERTIFICATE_NOT_FIT: 'Qualification does not fit',
    BAD_PRIOR_EXPERIENCE: 'Insufficient performance in the last assignment',
    OTHER_INVITEE_BOOKED: 'Another employee was booked',
    JOB_CANCELLED: 'Service was canceled',
    OTHER: 'Other reason',
  },
  certificates: 'Certificates',
  specialities: 'Specialties',
  transferredBy: 'Transferred by',
  createdBy: 'Created by',
  list: 'List',
  calendar: 'Calendar',
  shifts: {
    '0': 'Early',
    '1': 'Day',
    '2': 'Late',
    '3': 'Night',
  },
  shiftLetters: {
    '0': 'E',
    '1': 'D',
    '2': 'L',
    '3': 'N',
  },
  jobRequests: 'Job requests',
  userRole: 'Role',
  roleEnum: {
    0: 'Pooler',
    1: 'Dispatcher',
    2: 'Department Manager',
  },
  agencies: 'Agencies',
  continue: 'Continue',
  jobTypes: 'Job Types',
  tiles: 'Tiles',
  inEmployment: 'In Employment',
  saved: 'Saved',
  profileSaved: 'Profile saved',
  jobSaved: 'Service saved',
  serverError: 'Server error',
  wrongOrExpiredToken: 'Token is wrong or expired',
  documentUploaded: 'Document uploaded successfully',
  saveJobBeforeTransfer: 'Please save your changes before transferring',
  documentRemoved: 'Document removed successfully',
  xNewJobsCreated: '{{count}} new services created',
  noUserConnectedWithMicrosoft: 'No user connected with Microsoft account',
  loginExpired: 'Your login has expired. Please log in again to continue',
  multidayUsersInvitedAndBooked:
    '{{inviteCount}} employees invited and {{bookCount}} employees booked',
  multidayUsersInvited: '{{count}} employees invited',
  multidayUsersBooked: '{{count}} employees booked',
  registerSuccess:
    'Thank you for your submission, we will get back to you shortly',
  notAllowed: 'You are not allowed to do that',
  notSupported: 'Your browser does not support this feature',
  sentInvitation: 'Invitation sent',
  maxFileUploadExceeded: 'Max. file size exceeded',
  noCustomerAssigned: 'No customer has been assigned to this user',
  phoneNumberOccupied: 'This number is already taken',
  newJobCreated: 'Service created',
  jobClosed: 'Service completed',
  reAskedInvitee: 'Employee requested again',
  jobTransferred: 'Service transferred',
  jobCanceled: 'Service canceled',
  inviteeCanceled: 'Booked employee was canceled',
  passwordResetEmailSent: 'Password reset email sent',
  xJobsDeclined: '{{count}} services were declined',
  jobOverlapsDetectedForNames: 'Shifts overlap for {{names}}',
  userNotFound: 'User not found',
  couldntCreateTag: 'Could not create tag',
  tagAlreadyExists: 'Tag already exists',
  tagStillInUse: 'Tag is still in use',
  tagAlreadyOnOrganisation: 'Tag is already on organization',
  couldntDeleteTag: 'Could not delete tag',
  successfullyDeletedTag: 'Tag successfully deleted',
  tagAdded: 'Tag added',
  tagRemoved: 'Tag removed',
  userRemovedFromPool: 'User was removed from the pool',
  usernameOrPasswordWrong: 'Email or password incorrect',
  cannotViewMoreThan90Days: 'The date range cannot be greater than 90 days.',
  demoResetNotice:
    'Welcome to the demo of inpool. Please note that email and SMS notifications are disabled by default in the demo. All data will be reset overnight',
  optInEmailMessage:
    'Please confirm the new email address using the confirmation link we sent you via email',
  optInPhoneMessage:
    'Please confirm the new phone number using the confirmation link we sent you via SMS',
  sentNewSMSToken: 'SMS confirmation code sent.',
  confirmEmailLink:
    'Please confirm your email address by clicking the link we sent to you via email.',
  optInEmailExists: 'An account with this email address already exists.',
  optInPhoneExists: 'An account with this phone number already exists.',
  optInSuccessMessage: 'The change was successfully confirmed',
  optInErrorMessage:
    'The change could not be completed. Either the link used was expired, incomplete, or invalid for this user. Please try again',
  alreadyInPool: 'A user with this email address is already in the pool',
  alreadyRequested: 'The user has already been invited',
  alreadyAdded: 'This user has already been added',
  changeEmailNotAllowedForNewUser:
    'Email address cannot be changed when creating a new user',
  userCreated: 'The user was successfully created',
  savedDefaultFilter: 'The filter was successfully saved as default',
  userInvitedAgain: 'The user was invited again',
  userUnlocked: 'The user was unlocked',
  connectionLost: 'Connection lost. Attempting to reconnect...',
  connectionOffline:
    'Connection lost. Please ensure you are connected to the internet and reload the page.',
  hoursTransferred: 'Hours transferred',
  successfullyAddedInvitee: 'Employee successfully added',
  JobNotFound: 'Service not found',
  userAlreadyExistsAsDispo: 'The user is already registered as a dispatcher',
  userAlreadyExistsAsPooler: 'The user is already registered as an employee',
  JobNotOpen: 'Service is no longer open',
  SecretInvalid: 'Not authorized',
  InvalidForm: 'Please fill out all required fields',
  JobAutomaticallyClosed: 'Service was successfully completed',
  transferDeclined: 'Service was successfully declined',
  removedSuccessfully: 'Successfully removed',
  downloadedSuccessfully: 'Successfully downloaded',
  fileNotFound: 'File could not be found',
  jobInsertError: 'Error creating service',
  multiJobInsertError: 'One or more services could not be created',
  cantBookInvitee: 'The employee could not be booked',
  cantBookReasonUserBlacklistedDepartment:
    'The employee has blacklisted this department',
  cantBookReasonDepartmentNotAssigned:
    'The employee does not have the job department assigned',
  cantBookReasonNotAvailable: 'The employee is not available for this job',
  cantBookReasonDepartmentBlacklistedUser:
    'The department has blacklisted this employee',
  cantBookReasonCanBeBooked: 'The employee can be booked for this job',
  loginForbidden: 'Login denied',
  authCodeResent: 'Confirmation code resent',
  phoneNotFound: 'No valid phone number found.',
  phoneNotVerified: 'Phone number is not verified.',
  contactSupport: 'Please contact support.',
  InviteesAlreadyExists: 'Pooler already exists',
  inviteeTransferred: 'Successfully rescheduled',
  inviteeDoesNotFitCriteria: 'Invited employee does not meet criteria',
  inviteeNoLongerFitCriteria: 'Invited employee no longer meets criteria',
  requiredUsersBelowBookedCount:
    'Required employees cannot be fewer than already booked',
  inviteeInvitedTwice: 'Employee has already been invited',
  duplicateInvitationError:
    'There is a problem with the service (Duplicate invitation). Please reload the page and try again.',
  duplicateInvitationErrorUnclearableStatus:
    'There is a problem with the service (Duplicate invitation). Please contact support immediately.',
  linkCopied: 'Link copied',
  inviteeHasNotHadMinimumRest:
    'Invited employee has not met the minimum rest period',
  externalNoLongerDraft:
    'The service is no longer in draft in the external transfer',
  userBookedSuccessfullyEmployment:
    'The employee was booked for the assignment',
  userSuccessfullySubmittedAsEmploymentPossibleCandidate:
    'The employee was successfully submitted as a possible candidate for the assignment',
  userCanceledSuccessfullyEmployment:
    'The employee was canceled for the assignment',
  userBookedSuccessfullyJob: 'Employee successfully booked for the service',
  employmentCanceled: 'The assignment was canceled',
  employeesInvitedSuccessfully: 'Employees successfully invited',
  employmentCreated: 'Assignment successfully created',
  requiredFieldsMissing: 'Please fill out all required fields',
  changesSaved: 'Changes saved',
  jobRequestInsertError: 'Error creating request',
  newJobRequestCreated: 'Request created',
  xNewJobRequestsCreated: '{{count}} Requests created',
  jobRequestRetractError: 'Error retracting request',
  jobRequestRetracted: 'Request retracted',
  jobRequestApproved: 'Request approved',
  jobRequestRejected: 'Request rejected',
  settings: 'Settings',
  superAdmin: 'Super Admin',
  demoSettings: 'Demo Settings',
  jobMatrix: 'Request Overview',
  demoValidUntil: 'Demo valid until',
  qualification: 'Qualification',
  potentialInviteeCount: 'Available',
  noShiftsForWeekDaysHint: 'No shifts available for this weekday',
  noShiftsForJobTypeHint: 'No shifts available for this service type',
  noShiftsAvailableHint: 'No shifts configured for this department',
  cancelSomething: 'Cancel',
  submitPossibleCandidate: 'Submit as candidate',
  sickness: 'Illness',
  accident: 'Accident',
  PersonnelDeclined: 'Personnel declined',
  customerDeclined: 'Customer canceled',
  restTimeAfter7WorkingDays: 'Rest time after 7 working days not observed',
  otherJobOffer: 'Other job offered',
  noCapacity: 'No capacity',
  requesterOverview: 'Requester Overview',
  requesterAssignmentReportDescription:
    'Overview of all requesters and their authorizations',
  autoBookInviteesCardTitle: 'Auto Book Invitees',
  autoBookInvitees: 'Auto Book Invitees',
  autoBookInviteesDepartmentDefault:
    'Auto Book Invitees by default on departments',
  autoBookSelfSignIns: 'Auto Book Self Sign Ins',
  autoBookSelfSignInsDepartmentDefault:
    'Auto Book Self Sign Ins by default on departments',
  jobMatrixHideCanceledJobs: 'Hide canceled jobs in request overview',
  sharedPoolCustomers: 'Customers with access to Shared Pool',
  sharedPoolCanDirectBook: 'can directly book',
  noSharedPoolCustomers: 'No customers with access to this Shared Pool found.',
  jobMatrixForRequester: 'Show request overview for requesters',
  jobMatrixCertificatePriority:
    'Certificate Priorities for the Request Overview',
  jobMatrixCertificatePriorityDescription:
    'The priorities are considered in the request overview from top to bottom. Services with multiple qualifications are only displayed for the highest priority.',
  groupBy: 'Group by: ',
  preventDirectAcceptWithinHoursPerShift:
    'Disable direct booking within x hours before job start (1.5 = 1 hour 30 minutes)',
  statusAfterCancelEnum: {
    AVAILABLE: 'Available',
    UNAVAILABLE: 'Unavailable',
    WORKING: 'Working',
    UNKNOWN: 'Unknown',
  },
  smsDisabledForDemo: 'SMS sending is disabled for demo environments',
  userExistsInDemo:
    'This user exists in a demo, please contact inpool support.',
  userAlreadyExists: 'The user is already registered',
  demoSetupCompleted: 'Demo environment successfully created',
  demoExpired: 'Your demo version has expired',
  jobs: 'Services',
  jobsFromDate: 'Services on {{datum}}',
  assignments: 'Assignments',
  logout: 'Logout',
  admin: 'Admin',
  profile: 'Profile',
  tariffs: 'Tariffs',
  jobDefaults: 'Default Values',
  customerFlags: 'Admin Options',
  poolerTypes: 'Poolertypes',
  dashboard: 'Dashboard',
  activationPending: 'Activation Pending',
  cancelReasons: 'Cancel Reasons',
  agencyPriorities: 'Agency Priorities',
  jobRequestApproval: 'Job Requests',
  transferList: 'Transfer List',
  showByTranscribedAtDate: 'Show by transcribed date',
  only1kTranscribeJobsShown:
    'Only the newest 1,000 services are displayed. Narrow the search if necessary.',
  only1kTranscribeJobsByDateShown:
    'Only the last 1,000 transferred services are displayed. Narrow the search if necessary.',
  transcribedAt: 'Transcribed at',
  transcribedBy: 'Transcribed by',
  bookedInvitee: 'Booked Employee',
  noJobsToTranscribe: 'There are no services that need to be transferred 🎉',
  noJobsTranscribedYet: 'No services have been transferred yet',
  manualTranscribeJobListDescription: 'Overview of manual job transfers',
  demandReasons: 'Demand Reasons',
  requestOverview: 'Request Overview',
  certificateGroups: 'Certificate Groups',
  customCriteria: 'Custom Criteria',
  addCustomCriteriaGroup: 'Add Custom Criteria',
  customCriteriaTypeToggle: 'Toggle',
  customCriteriaTypeSelect: 'Select',
  defaultValue: 'Default',
  defaultValueForPooler: 'Default value on profile',
  defaultValueForJob: 'Default value on job',
  customCriteriaBlockingToggle:
    'Blocks the employee if the employee has the criterion, but the job does not.',
  multipleSelection: 'Multiple selection',
  addOption: 'Add option',
  customCriteriaUserEditable: 'Editable by pooler on own profile',
  customCriteriaEnableOnJobRequest: 'Show on job request',
  jobsPool: 'Job Pool',
  employmentsPool: 'Temporary Pool',
  addTariff: 'Add Tariff',
  hourlyWage: 'Hourly Wage CHF',
  addDefault: 'Add Default',
  enablePoolerTypes: 'Enable Pooler Types',
  enableDemandReasons: 'Enable Demand Reasons',
  prioritizeEmployeeLastName: 'Display lastname before firstname',
  transferredJobsNoLongerActionRequired:
    'transferred open jobs are shown as gray',
  approvedJobRequestsNoLongerActionRequired:
    'approved job requests are shown as gray',
  enableCopyDateOnDuplicate: 'Copy date on duplicate',
  enableAutoDirectAccept: 'Enable auto-accept',
  preventAutoDirectAcceptWithinHours:
    'Disable auto-accept within x hours of job start',
  allowIgnoreUserPreferenceDepartmentBlacklist:
    'Allow ignoring user preference department blacklist',
  preventChangingOfCreator: 'Prevent changing the creator of a service',
  timeTrackingEnabled: 'Enable time tracking',
  timeTrackingDescriptionRequiredOnChange:
    'Description required on change of time tracking',
  timeTrackingAutoApproveInDays:
    'Time tracking automatically approve after X days if not approved by dispatcher',
  timeTrackingDefaultPauseInHours: 'Default pause in hours',
  enableJobRequestApproval: 'Job Request Approval Required',
  enableCaseNumberInJobRequests: 'Enable case number in job requests',
  addNotification: 'Add Notification',
  noNotificationsConfigured: 'No Notifications Configured',
  addTimeRange: 'Add Time Range',
  timeFrom: 'From',
  timeTo: 'To',
  wholeDay: 'Whole Day',
  enableRequestOverview: 'Show request overview',
  enableSectionToggleInJobMatrix: 'Enable section toggle in request overview',
  disableTimetrackingForOwnPoolers: 'Disable time tracking for own poolers',
  enableTimetrackingForNewOrganisationsByDefault:
    'Enable time tracking for new organizations by default',
  disableApproveTimetrackingNotificationsForTransfers:
    'Disable time tracking approval notifications for transfers',
  requestOverviewHideCanceledJobs: 'Hide canceled jobs in request overview',
  requestOverviewForRequester: 'Show request overview for requesters',
  enableMonthlyHours: 'Show monthly hours',
  enableTranscribeJobList: 'Enable transcribe job list',
  enableTranscribeJobListDescription:
    'List for transfer of bookings and cancellations to another software',
  exceptions: 'Exceptions',
  requestOverviewCertificatePriority:
    'Certificate Priorities for the Request Overview',
  requestOverviewCertificatePriorityDescription:
    'The priorities are considered in the request overview from top to bottom. Services with multiple qualifications are only displayed for the highest priority.',
  addCertificatePriority: 'Add Certificate Priority',
  addPoolerType: 'Add Pooler Type',
  confirmPoolerTypeDeletion:
    'Are you sure you want to delete this pooler type? \n There are {{count}} poolers assigned to this type.',
  addDemandReason: 'Add Demand Reason',
  enableDescriptions: 'Enable Description',
  addCancelReason: 'Add Cancel Reason',
  addCertificateGroup: 'Add Certificate Group',
  addConditionalTransfer: 'Add Transfer Conditions',
  hoursBeforeJobStart: 'Rule active from x hours before job start',
  blockingHours: 'Lead time',
  conditionalTransfersDescription:
    'Here you can define the conditions for the transfer to agents. The conditions will only be applied if the service recipient is within the specified time. The first matching condition is always applied. If no time is specified, the condition is always applied',
  addCustomerGroup: 'Add Customer Group',
  addConditionGroup: 'Add condition group',
  jobsTransfers: 'Job Pool Transfer',
  employmentsTransfers: 'Temporary Pool Transfer',
  sharedPool: 'Shared Pool',
  agencyPrioritiesDescription:
    'Here you can set the priorities for the transfer to agents.',
  supplier: 'Agency',
  loadingReport: 'Loading Report',
  timeSpan: 'Timespan',
  noTimeSpanSelected: 'No Timespan Selected',
  open: 'Open',
  jobId: 'Job ID',
  correctionReason: 'Correction Reason',
  dispoCorrectionReason: 'Correction Reason (Dispo)',
  poolerCorrectionReason: 'Correction Reason (Pooler)',
  departmentId: 'Department ID',
  perAgency: 'Per Agency',
  timeTrackingReport: 'Time Tracking Report',
  timeTrackingReportDescription: 'Export of recorded working hours per service',
  shiftsPlanningReport: 'Shift Planning',
  jobsForInvoice: 'Services for Invoice',
  jobsForInvoiceDescription:
    'List of all services for invoicing for the selected timespan',
  shiftsPlanningReportDescription:
    'List of all booked or canceled assignments for the selected timespan',
  jobOverviewReport: 'Job Overview',
  jobOverviewReportDescription: 'Lists all jobs for the selected timespan',
  activityReport: 'Inactivity',
  activityReportDescription:
    'List of all poolers who were inactive for the selected timespan',
  externalCancellationTime: 'External Cancellation Time',
  externalCancellationsDescription:
    'Overview of all externally canceled services',
  canceledAt: 'Canceled at',
  canceledBy: 'Canceled by',
  cancelReason: 'Cancel Reason',
  cancelReasonDescription: 'description of Reason for cancellation',
  noAvailabilities: 'No Availabilities',
  noBookings: 'No Bookings',
  poolerOverview: 'Pooler Overview',
  poolerAssignmentReportDescription:
    'Assignment of poolers per clinic/department or pooler including education and additional training',
  userAvailabilityReport: 'User Availability',
  userAvailabilityReportDescription: 'User availability',
  bookedVsAvailablePercentage: 'Booked / Available in %',
  availableUserJobPlanningReport: 'Employee Planning',
  availableUserJobPlanningDescription:
    'Overview of all commitments for all open services.',
  poolerReactionTime: 'Pooler Reaction Time',
  smsUsage: 'SMS Usage',
  smsUsageDescription:
    'Overview of all sent text messages (Cannot be limited to departments)',
  poolerReactionTimeDescription:
    'Overview of all poolers and their reaction times.',
  bookedEmployee: 'Booked Employee',
  certificatesOfBookedEmployee: 'Certificates of Booked Employee',
  desiredCertificates: 'Desired Certificates',
  internalDescription: 'Internal Description',
  archivedJobsReport: 'Archived Services',
  archivedJobsReportDescription:
    'All archived services with shifts and booked employees',
  transferReport: 'Transfers',
  transferReportDescription:
    'Overview of all transfers for the selected timespan',
  availabilityUpdatesReport: 'Availability Updates',
  availabilityUpdatesReportDescription: 'Overview of all availability changes',
  internalId: 'Internal ID',
  updatedAt: 'Updated at',
  updatedBy: 'Updated by',
  availabilityStatusEnum: {
    AVAILABLE: ' Available',
    UNAVAILABLE: 'Unavailable',
    WORKING: 'In Progress',
  },
  disponentOverview: 'Disponent Overview',
  disponentAssignmentReportDescription:
    'Overview of all dispatchers and their authorizations',
  restrictedToDepartments: 'Restricted to departments',
  restrictedToCertificates: 'Certificates',
  planningMatrixReport: 'Planning Matrix',
  planningMatrixReportDescription:
    "Planning matrix for the optimal distribution of bookable employees. Note: Only the 'from' date is taken into account for this report",
  planningMatrixReportHeaderRowTitle: 'Instructions: \n',
  planningMatrixReportHeaderRowDescription:
    'Enter a "b" for the planned bookings in the corresponding cell.',
  hoursByDepartment: 'Hours by Department',
  hoursByDepartmentDescription: 'Hours by Department',
  customerConnectionsReport: 'Connected Customers',
  customerConnectionsReportDescription:
    'Overview of all customers that are connected via transfers or sharedpool',
  currentlyActiveEmployments: 'Currently Active Employments',
  currentlyActiveEmploymentsDescription:
    'A list of all booked temporary employments for the selected timespan with location and workload',
  connectedViaJobs: 'via Jobs',
  connectedViaEmployments: 'via Temporary Employments',
  departmentDeselected: 'Department deselected',
  departmentDeselectedByPooler: 'This department was deselected by the pooler',
  caseNumber: 'Case Number',
  caseNumberShort: 'Case nr.',
  costCenter: 'Cost Center',
  multiDayEdit: 'edit series',
  waiting: 'waiting',
  invited: 'invited',
  intrested: 'Interested',
  notIntrested: 'Not Interested',
  partiallyIntrested: 'Partially Interested',
  reportedAvailable: 'reported available',
  hasAvailablePeople: 'Available People',
  restViolationsDetected: 'Rest time not guaranteed',
  pricePerHourIfNotSpecified: 'Price per hour (if no fixed tariff agreed)',
  confirmIgnoreRestViolations:
    '{{violations}}\n\nDo you want to continue anyway?',
  waitingForResponse: 'Waiting for Response',
  thereAreXJobsWithOpenInvitations:
    'There are {{count}} services with open confirmations for this day.',
  thereIsAnOpenInvitationForThisDay:
    'There is an open confirmation for this day.',
  shouldCancelOpenInvitations: 'Should these be cancelled?',
  cancelOpenInvitations: 'Cancel services',
  keepOpenInvitations: 'Keep services open',
  cancelOpenInvitation: 'Cancel service',
  keepOpenInvitation: 'Keep service open',
  noOpenInvitations: 'No Open Invitations',
  createNewJob: 'New Service',
  nextTransferAt: 'next transfer at {{date}}',
  loadingJobs: 'Loading Services...',
  noJobsFound: 'No Services Found',
  editTimes: 'Edit Times',
  editShifts: 'Edit Shifts',
  criteria: 'Criteria',
  readOnlyOwnerAccessHint:
    'This job was created by an agency and therefore cannot be edited.',
  careSector: 'Experience / Care Sector',
  accept: 'accept',
  accepted: 'accepted',
  partialAccept: 'partially accept',
  partialAccepted: 'partially accepted',
  answered: 'Answered',
  partialAcceptEdit: 'Edit times',
  acceptAndClose: 'accept and close',
  reask: 'ask again',
  setToUnavailable: 'set to unavailable',
  setToAvailable: 'set to available',
  includeUndecided: 'Include Unknown Availability',
  previousJobsInThisDepartmentOfLast3Months:
    'Services of the last 3 months in this department / organization',
  previousEmploymentsInThisDepartmentOfLast3Months:
    'Employments of the last 3 months in this department / organization',
  upcoming: 'upcoming',
  invite: 'invite',
  book: 'book',
  inviteAndBook: 'invite {{inviteCount}} and book {{bookCount}}',
  inviteAndSuggest: 'invite {{inviteCount}} and suggest {{bookCount}}',
  archived: 'archived',
  cancelJob: 'cancel',
  conclude: 'close',
  availableEmployees: 'available employees',
  requestedEmployees: 'requested employees',
  acceptedAt: 'Accepted on {{date}} ({{distance}})',
  declinedAt: 'Declined on {{date}} ({{distance}})',
  wasDeclinedAt: 'Was declined on {{date}} ({{distance}})',
  possibleCandidateAt: 'Candidate submitted on {{date}} ({{distance}})',
  bookedAtWithDate: 'Booked on {{date}} ({{distance}})',
  cancelledAtWithDate: 'Cancelled on {{date}} ({{distance}})',
  transcribedAtWithDate: 'Transcribed on {{date}} ({{distance}})',
  noResponseGiven: 'Service has already been closed',
  partialAcceptedAt: 'Partially accepted on {{date}} ({{distance}})',
  jobAlreadyOccupied: 'This service has already been assigned',
  jobAlreadyCanceled: 'This service has already been canceled',
  canceled: 'Canceled',
  automatically: 'automatically',
  immediately: 'immediately',
  soon: 'soon',
  closeJobImmediately: 'Close service immediately',
  bookAndClose: 'book and close',
  transferred: 'transferred',
  transferredAt: 'transferred at {{date}} ({{distance}})',
  nextTransfer: 'next transfer',
  tooManyJobs:
    'Only the next {{limit}} services are displayed. Limit the search if necessary.',
  saveDefaultFilter: 'Save filters',
  showCanceledJobs: 'Show canceled services',
  onlyShowCanceledJobs: 'Show only canceled services',
  showOnlyActionRequiredBookableJobs:
    'Show only services with a bookable person',
  showOnlyActionRequiredNoOpenInviteesJobs:
    'Show only services with no open invitees',
  onyShowBookedJobs: 'Show only booked jobs',
  icsDownload: 'Calendar',
  activateMultipleShifts: 'Activate split shifts',
  requiredEmployees: 'Required Employees',
  submitAsPossibleCandidate: 'Submit as candidate',
  transferNow: 'Transfer now',
  transferAutomatically: 'Transfer automatically',
  preventDirectAccept: 'Prevent direct booking',
  allowDirectAccept: 'Allow direct booking',
  directTransfer: 'Direct Transfer',
  declineJob: 'decline service',
  important: 'Important',
  confirmPoolerAvailability:
    'You are recording a manual service commitment. Please confirm that you have previously received a verbal commitment from the employee for this service.',
  will: 'will',
  transferInvitee: 'reschedule',
  poolerDoesNotHaveSelectedJobType:
    'The employee does not have the selected job type in their selected job types.',
  transferInviteeDepartmentNotAssignedTitle: 'Station not assigned',
  transferInviteeDepartmentNotAssignedWarning:
    'The selected employee is not assigned to this station or department. Do you want to complete the transfer anyway?',
  transferInviteeTransferAnyway: 'Transfer anyway',
  submitEmployees: 'Submit Employees',
  previouslyPossibleEmployeesSection: 'Employees you can resubmit',
  previouslyPossibleEmployeesHint:
    'After the job was reopened, these employees can be submitted again.',
  resubmitPreviouslyPossibleEmployee: 'Resubmit',
  user: 'Employee',
  booked_user: 'Booked employees',
  canceled_user: 'Canceled employees',
  shiftStart: 'Shift start',
  shiftEnd: 'Shift end',
  confirmPoolerWithNotes:
    'The person you want to book has the following notes:',
  onlyAvailableEnd: ' available',
  userPartiallyAcceptedForTime:
    'The employee has partially accepted for the specified time',
  confirmManyInvites: 'Are you sure you want to send more than 50 invitations?',
  addToField: 'Add to field',
  removeToField: 'Remove to field',
  restNotGuaranteed: 'Rest time not guaranteed',
  unknownAvailability: 'Availability unknown',
  unknown: 'Unknown',
  hasNote: 'Note available',
  note: 'Note',
  restTime: 'Rest time',
  deselectAllEmployees: 'Deselect All Employees',
  selectAllEmployees: 'Select All Employees',
  inviteXOfYPeople: 'Invite {{count}} employees',
  bookXPeopleDirectly: 'Book {{count}} employees immediately',
  addAnotherDate: 'Add another date',
  confirmJobAcceptAvailablePoolerPre: 'Do you want to apply for the service on',
  confirmJobAcceptAvailablePoolerPost: '?',
  confirmJobAcceptUnavailablePoolerPre: 'Make sure you are available on',
  confirmJobAcceptUnavailablePoolerPost:
    '. Do you want to apply for this service?',
  confirmAutoBookInviteeAcceptJob:
    'The commitment is binding and cannot be changed anymore.',
  repeatingJob: 'Repeating Service',
  createJobs: 'Create {{count}} services',
  editShiftTimes: 'Adjust service time',
  transferNowPre: 'Do you want to transfer this service to',
  transferNowAll: 'all agencies',
  transferNowPost: 'now?',
  transferToAll: 'Transfer all',
  automaticallyAt: 'automatically at {{date}} ({{distance}})',
  automaticallyAfterBlocked:
    'automatically once no longer blocked in ({{distance}})',
  blockedUntil: 'Blocked until: ',
  automaticallyImmediately: 'automatically immediately',
  declineReason: 'Decline reason',
  jobInPastWarning: {
    '0': 'This service is in the past. Please note:',
    '1': 'Employees can only be booked immediately',
    '2': 'No notifications will be sent',
    '3': 'Availabilities will not be considered',
  },
  confirmTransferReject: 'Are you sure you want to decline the service?',
  workTime: 'Working time',
  checkHours: 'Check Working time',
  recordHours: 'Record Working time',
  requiredUsersAmount: 'Number of required persons',
  deleteConfirmTitle: 'Remove dossier?',
  deleteConfirmContent: 'The dossier will be deleted and cannot be restored',
  internalInformation: 'internal informationen',
  internalInformationSubline:
    'This information is only visible for {{customerName}} and will not be sent along with the transfers',
  internalPoolers: 'internal poolers',
  bookedInvitees: 'Booked invitees',
  transfers: 'Transfers',
  internalNote: 'Internal Note',
  createdAt: 'Created at',
  closedJobTooltip: 'Booked at {{date}} ({{distance}})',
  transfersTooltip: 'Transferred / Total possible transfers',
  declinedTransfersTooltip: 'declined transfers',
  activeAutoTransfersTooltip: 'active automatic transfers',
  requests: 'Requests',
  bookedServices: 'Booked Services',
  archivedServices: 'Archived Services',
  hideAllRequests: 'Hide all missed services',
  monthlyWorkingHoursTooltip:
    '{{percentage}}% | {{current}}/{{total}} hours booked this month',
  assignment: 'Assignment',
  employment: 'Assignment',
  createNewEmployment: 'New Assignment',
  availabilityNotes: 'Availability Notes',
  availabilityNoteFormat: '{{start}} to {{end}}: {{note}}',
  possibleCandidates: 'Possible Candidate',
  showHistory: 'Show History',
  inviteAndCreate: 'Invite and Create',
  inviteAndSave: 'Invite and Save',
  cancelEmployment: 'Cancel Assignment',
  showCanceledEmployments: 'Show canceled assignments',
  tooManyEmployments:
    'Only the next {{limit}} assignments are displayed. Limit the search if necessary.',
  foundOtherPersonnel: 'Assignment has already been filled',
  creationMistake: 'Assignment was incorrectly recorded',
  notNeededAnymore: 'Assignment is no longer needed',
  otherReason: 'Other reason',
  employmentHasBeenOccupied: 'This assignment has already been filled',
  match: 'Match',
  addAvailabilityField: 'Add Availability',
  removeAvailabilityField: 'Remove Availability',
  qualifications: 'Qualifications',
  noEmployeesSubmitted: 'No employees submitted',
  declineEmployment: 'Decline assignment',
  deleteFileConfirmTitle: 'Remove dossier?',
  deleteFileConfirmContent:
    'The dossier will be deleted and cannot be restored',
  initialStartDate: 'Initial Start Date',
  initialEndDate: 'Initial End Date',
  initialWorkload: 'Initial Workload',
  transferConfirmationText:
    'Do you really want to complete the hours? The hours can no longer be edited afterwards.',
  submitConfirmationText:
    'Do you really want to release the hours? The hours can no longer be edited afterwards.',
  invalidBreakTime: 'Invalid work break',
  submitTimeTracking: 'Submit working hours',
  approveHours: 'Approve hours',
  bookDirectly: 'book immediately',
  suggestDirectly: 'submit immediately',
  suggest: 'suggest',
  personalInfoHelpText: 'Gender and Name',
  weNeedSomeData: 'We still need some data from you',
  confirmEmail: 'Confirm Email Address',
  pleaseConfirmEmail:
    'Please confirm the new email address using the confirmation link we sent you',
  resendSmsCode: 'Resend SMS code',
  resendConfirmationEmail: 'Resend Confirmation Email',
  smsConfirmationCode: 'SMS Confirmation Code',
  mobilePhoneExample: 'Mobile number (e.g. +41791234567)',
  mobilePhoneNumber: 'Mobile Phone Number',
  notShowingAllUsers:
    'Only {{count}} employees are shown. Use the search field to see other employees.',
  cancelBookedInvitee: 'Cancel booked employee',
  reason: 'Reason',
  declineInvitee: 'Decline employee',
  availabilityNote: 'Availability Note',
  noRest: 'The selected user cannot meet the rest period for this service.',
  createEmployment: 'Create assignment',
  shiftsLongName: {
    EARLY: 'Early Shift',
    DAY: 'Middle Shift',
    LATE: 'Late Shift',
    NIGHT: 'Night Shift',
  },
  calendarWeek: 'CW',
  selectedShiftsHint:
    'These are your selected available shifts. You can adjust the default in the settings.',
  inviteXUsers: 'Invite {{count}}',
  bookXUsers: 'Book {{count}}',
  dateRangeChips: {
    ALL: 'All',
    TODAY: 'Today',
    TOMORROW: 'Tomorrow',
    WEEK: 'This Week',
    NEXT_WEEK: 'Next Week',
    MONTH: 'This Month',
    NEXT_MONTH: 'Next Month',
    CUSTOM: 'Timespan',
    N30: '+30 Days',
    N90: '+90 Days',
    L30N30: '-30, +30 Days',
    L90: '-90 Days',
  },
  bookedForShift: {
    EARLY: 'booked for early shift',
    DAY: 'booked for middle shift',
    LATE: 'booked for late shift',
    NIGHT: 'booked for night shift',
  },
  editNote: 'Edit note',
  addNote: 'Add note',
  myAvailabilities: 'My Availabilities',
  myDepartments: 'My Departments',
  otherEmployeesAvailable:
    '{{date}} {{shiftLabel}}: {{count}} Other employees available',
  addUser: 'Add User',
  active: 'active',
  registered: 'registered',
  former: 'former',
  type: 'Type',
  notes: 'Notes',
  notesPlaceholder:
    'Special e.g. free on the weekend, or free on specific date',
  unavailabilityReason: 'Reason for Unavailability',
  unavailabilityReasonEnum: {
    HOLIDAY: 'Vacation',
    SICK: 'Sickness',
    TRAINING: 'Training',
    OTHER: 'Other',
  },
  editAvailability: 'Edit Availability',
  otherOrganisation: 'Other Organization',
  availabilitySelectionWarning: 'Attention: Additional information',
  availabilitySelectionWarningText:
    'There are additional information about this availability. Please check this.',
  restWarning: 'Rest time not guaranteed',
  inviteAgain: 'Invite again',
  restWarningLong:
    'The 11-hour rest period is not guaranteed. Please check the rest period manually.',
  unlock: 'Unlock',
  nextShiftStart: 'Next shift starts on:',
  lastShiftEnd: 'Last shift ends on:',
  downloadDossier: 'Download Dossier',
  removeFromPool: '{{ name }} really remove from the pool?',
  impersonate: 'Login as user',
  impersonateUser: 'Login as {{ name }}?',
  returnToUser: 'return to user',
  loadingProfile: 'Profile is loading',
  editingRequestedUserHint:
    'Not all information is available because the user has not yet accepted the collaboration request.',
  contactSettings: 'Contact Settings',
  getNotificationSms: 'Receive notifications via SMS',
  getNotificationEmail: 'Receive notifications via Email',
  getNotificationPush: 'Receive notifications via Push',
  twoFactorAuthEnabled: 'Two-Factor Authentication enabled',
  allowPushNotifications: 'Allow push notifications for this page',
  enableJobs: 'Enable Job Pool',
  enableEmployments: 'Enable Temporary Pool',
  getOwnJobConfirmations: 'Receive booking confirmations for own services',
  disableUnsavedChangesWarning: 'Disable unsaved changes warning',
  disabledEmails: 'Disabled Emails',
  creatorNotifications: {
    ACCEPTED_TIME_TRACKING: 'Time tracking accepted',
    ACTION_REQUIRED_ACCEPT_INVITEE: 'Service action required - accept pooler',
    ACTION_REQUIRED: 'Service action required',
    APPROVE_TIME_TRACKING_FOR_CREATOR: 'Approve working time',
    APPROVE_TIME_TRACKING_REMINDER_FOR_CREATOR:
      'Approve working time – reminder',
    BOOKED_INTERNAL: 'Service booked (internal pool)',
    BOOKED_EXTERNAL: 'Service booked (external pool)',
    POSSIBLE_CANDIDATE: 'Possible candidate (service)',
    INVITEE_CANCELED: 'Booked pooler canceled service',
    JOB_CANCELED: 'Service canceled',
    TRANSFER_DECLINED: 'Transfer declined (service)',
    INVITEE_REPLACED: 'Pooler replaced',
    EMPLOYMENT_BOOKED_INTERNAL: 'Assignment booked (internal pool)',
    EMPLOYMENT_BOOKED_EXTERNAL: 'Assignment booked (external pool)',
    EMPLOYMENT_INVITEE_CANCELED: 'Booked pooler canceled assignment',
    EMPLOYMENT_ACTION_REQUIRED_ACCEPT_INVITEE:
      'Assignment action required - accept pooler',
    EMPLOYMENT_ACTION_REQUIRED: 'Assignment action required',
    EMPLOYMENT_CANCELED: 'Assignment canceled',
    EMPLOYMENT_INFORMATION_CHANGED: 'Assignment information changed',
    EMPLOYMENT_POSSIBLE_CANDIDATE: 'Possible candidate (assignment)',
    EMPLOYMENT_TRANSFER_DECLINED: 'Transfer declined (assignment)',
    JOB_REQUEST_ACCEPTED: 'Job request accepted',
    JOB_REQUEST_DECLINED: 'Job request declined',
    JOB_RETRACTION_REQUEST_ACCEPTED: 'Service retraction request accepted',
    JOB_RETRACTION_REQUEST_DECLINED: 'Service retraction request declined',
  },
  noNotificationSelected:
    'If you do not activate any of the two options or push, you will not be automatically informed of new service requests.',
  noShiftSelected:
    'If no shift is activated, you will not receive service requests.',
  qualificationsProfileEditText:
    'The following information cannot be edited by you. If it is incorrect, please contact your employer.',
  jobSettings: 'Service settings',
  weWillContactYouAboutActivation:
    'Thank you for submitting your documents. We will get back to you within one working day.',
  submitDocuments: 'Submit Documents',
  showOnlySelected: 'Show only selected departments',
  disabledByPooler: 'disabled by employee',
  blacklistedByDepartment: 'blocked by the department',
  EARLY: 'Early shift',
  DAY: 'Middle shift',
  LATE: 'Late shift',
  NIGHT: 'Night shift',
  yourEmailWasSetTo: 'Your email address was set to',
  wasChangedAt: 'changed at',
  yourPhoneWasSetTo: 'Your phone number was set to',
  notConnected: 'Not connected',
  loginSystems: 'Logins',
  additionalInformation: 'Additional Information',
  itKnowledge: 'IT Knowledge',
  clothingSize: 'Clothing Size',
  height: 'Height',
  fileUploadInfo: 'Drag and drop or click to upload dossier',
  yourDocuments: 'Your Documents',
  uploadedDocuments: 'Existing documents',
  pleaseUploadFollowingFilesForUnlock:
    'Please provide us with the following documents (if available) so we can unlock your account as soon as possible',
  curriculumVitae: 'Resume',
  graduations: 'Degrees',
  addGraduations: 'Add degree',
  jobReferences: 'Job references',
  carLicenceOptional: "Driver's license (optional)",
  permitsBGC: 'Permits (B / C / G)',
  defaultShiftsHint: 'The selected shifts will be respected by default',
  defaultJobTypesHint:
    'The selected service types will be respected by default',
  noJobTypeSelected:
    'If no service type is activated, you will not receive service requests.',
  canCreateDispoUsers: 'Can create dispatchers',
  canCreatePooler: 'Can create poolers',
  uploadDossier: 'Upload Dossier',
  manage: 'manage',
  read: 'read',
  see: 'see',
  update: 'edit',
  delete: 'delete',
  canPooler: 'can pooler',
  canPermission: 'Can Permissions',
  canManageTranscribeJobList: 'Can manage transcribe job list',
  canTransfers: 'Can transfer jobs and book suggestions',
  canSharedPool: 'Can direct book external poolers (SharedPool)',
  canTariffAdmin: 'Has admin access to tariffs',
  canEditAssignmentDefaults: 'Can edit standard service descriptions',
  canCustomerAdmin: 'Can edit admin settings',
  canDispos: 'can dispatchers',
  canJobAccess: 'can see job pool',
  canEmploymentAccess: 'can see temporary pool',
  canRequester: 'can requesters',
  canRequestsAccess: 'can view job requests',
  canApproveJobRequests: 'can approve job requests',
  canApproveHours: 'can approve hours',
  joinDate: 'Join Date',
  leaveDate: 'Leave Date',
  ccEmailHint: 'Please enter email addresses separated by commas.',
  permissions: 'Permissions',
  adminPermissions: 'Admin Permissions',
  car: 'Mobility',
  dateOfBirth: 'Date of Birth',
  location: 'Location',
  zip: 'ZIP',
  departmentAccess: 'Department Access',
  checkOwnAvailability: 'Consider own availability',
  poolRequestTitle: 'Collaboration Request',
  poolRequestText:
    'would like to add you to their pool. Allow access to your profile and availabilities and allow service requests?',
  dispoRequestTitle: 'Invitation as Dispatcher',
  dispoRequestText:
    'wants to add you as a dispatcher. Do you want to accept the invitation?',
  organisationRequestTitle: 'New Location',
  organisationRequestText:
    'Would you like to receive service requests for this location in the future?',
  moreLink: 'to the website',
  openJobs: 'Open Services',
  newestRequests: 'Newest Requests',
  possibleJobs: 'Possible Services',
  noMatchingEmployments: 'No matching assignments found',
  noMatchingJobs: 'No matching services found',
  matchingOffers: 'Matching Offers',
  possibleEmployments: 'Possible Assignments',
  nextJob: 'Next Service',
  actionRequiringJobs: 'Action-required Services',
  nextEmployment: 'Next Assignment',
  pendingTimetrackingJobs: 'Pending Timetracking',
  noJobFound: 'No service found',
  noEmploymentFound: 'No assignment found',
  showAllJobs: 'Show all services',
  showAllEmployments: 'Show all assignments',
  userWasInvited: 'User was invited.',
  userWasReasked: 'User was re-invited.',
  jobReopenedInviteNotificationSent:
    'A renewed request was sent to the user after the job was reopened.',
  jobReminderSent: 'Service reminder sent',
  inviteReminderSent: 'Invite reminder sent',
  userHasAccepted: 'User has accepted.',
  userHasDeclined: 'User has declined.',
  userHasPartiallyAccepted: 'User has partially accepted.',
  userHasEditedPartialTimes: 'User has adjusted the partially accepted times.',
  userWasAccepted: 'User was booked.',
  userWasSubmittedAsPossibleCandidate:
    'User was submitted as a possible candidate',
  userWasTransferredFrom: 'User was transferred from',
  userWasTransferredTo: 'User was transferred to',
  userWasDeclined: 'User was declined.',
  userBookedOnAnotherJob: 'User was booked on another service.',
  userAvailableBecauseJobCancelled:
    'User is available again because another service was canceled.',
  userSetToAvailable: "User was set to 'Available' by a dispatcher.",
  userSetToUnavailable: "User was set to 'Unavailable' by a dispatcher.",
  userWasCancelled: 'User was canceled.',
  invitedByCategory: 'User was invited via {{category}}.',
  acceptedByCategory: 'User was booked via {{category}}.',
  cancelledByCategory: 'User was canceled via {{category}}.',
  declinedByCategory: 'User was declined via {{category}}.',
  reAskedByCategory: 'User was re-asked via {{category}}.',
  userSubmittedAsPossibleCandidate:
    'User was submitted as a possible candidate',
  userSelfSignIn: 'User without an invitation made themselves available',
  userSelfSignInWithAvailability:
    'User with availability made themselves available',
  userSelfSignInWithoutAvailability:
    'User without availability made themselves available',
  userSelfSignInHasDeclined: 'User without an invitation has declined.',
  userWasReplaced: 'User was replaced by another pooler.',
  oClock: "o'clock",
  by: 'by',
  history: 'History',
  toOldJob: 'To the old service',
  toNewJob: 'To the new service',
  userReportedForSelfSignIn: 'User has reported as available for the service',
  requestShift: 'Request Shift',
  approve: 'Approve',
  sendXRequests: 'Send {{count}} requests',
  retract: 'Retract',
  requestRetraction: 'Request retraction',
  jobRequestRequestRetraction: 'Retraction requested',
  requestRetractionRequestedAt:
    'Retraction requested by {{firstName}} {{lastName}} at {{date}}',
  approveRetractionOnRequest: 'Approve retraction',
  rejectRetractionOnRequest: 'Reject retraction',
  requestOpenedAt: 'Request opened at {{date}}',
  requestApprovedAt: 'Accepted at{{date}}',
  requestApprovedAtBy: 'Accepted at {{date}} by {{name}}',
  requestRejectedAt: 'Request declined at {{date}}',
  requestRejectedAtBy: 'Request declined at {{date}} by {{name}}',
  requestBookedAt: 'Booked at {{date}}',
  requestArchivedAt: 'Request archived at {{date}}',
  requestCanceledAt: 'Canceled at {{date}}',
  requestRetractedAt: 'Request retracted at {{date}}',
  noActiveDepartment: 'Please select a department',
  noOpenJobRequests: 'No open service requests',
  pastJobs: 'Past Services',
  pastThreeMonthsDescription: 'in the last 3 months',
  in: 'at',
  worked: 'worked',
  moreThanThreeMonthsDescription: 'More than 3 months ago',
  noPastJobs: 'No past services',
  planningMatrix: 'Planning matrix',
  noOpenJobs: 'no open jobs',
  clearAllFilters: 'Clear filters',
  support: 'Support',
  supportTextUniversaljob:
    'If you have any questions or problems, please do not hesitate to contact us:',
  supportText: 'For any issues, please feel free to contact support:',
  supportTextNotLoggedIn:
    'If you have any questions or problems, please do not hesitate to contact your employer or alternativly reach out to us by email.',
  downloadGuideTextInformal: 'You can download our guide here:',
  downloadGuideTextFormal: 'You can download our guide here:',
  downloadGuideTextForPooler: 'You can download our guide for poolers here:',
  downloadGuideTextForRequester:
    'You can download our guide for requesters here:',
  phoneContactOutsideOpeningHours:
    'You can reach us by phone outside of our opening hours at:',
  supportTextPooler:
    'If you have any questions or problems, please do not hesitate to contact your employer.',
  supportTextRequester:
    'If you have any questions or problems, please do not hesitate to contact your employer.',
  deleteProfileText:
    'If you want to delete your account, please contact us by email.',
  deleteProfileTextNotLoggedIn:
    'If you want to delete your account, please contact us by email.',
  workDays: 'Monday to Friday',
  title: 'Title',
  welcomeTextDemoRegistration:
    'Welcome to the inpool demo. You can configure your individual demo environment in just a few steps and then test inpool for free.',
  startButton: 'Start',
  configureDemoTitle: 'Configure Demo',
  isAgencyQuestion: 'Are you a staffing agency?',
  organizationNameLabel: 'What is the name of your organization?',
  monthlyServicesLabel: 'How many services will you book per month?',
  demoOrganisationType: {
    AGENCY: 'Staffing Agency',
    HOSPITAL: 'Hospital / Clinic',
    PSYCHIATRY: 'Psychiatry',
    LONGTERM_CARE: 'Long-term Care',
    SPITEX: 'Home Care',
  },
  submitButton: "Let's go",
  generatingTitle: 'Demo is being set up',
  generatingText: 'We are now creating your demo environment, please wait...',
  redirectingToDashboard: 'You will be redirected to the dashboard...',
  fillAllFields: 'Please fill in all fields',
  loadingSteps: {
    creatingOrganization: 'Organization is being created',
    generatingEmployees: 'Employees are being generated',
    generatingOpenJobs: 'Open services are being generated',
    generatingArchivedJobs: 'Archived services are being generated',
  },
  welcomeTitle: 'Hooray, you made it...',
  welcomeTextDemoUserSetup: 'The demo is now set up.',
  welcomeTextDemoUserSetup2:
    'So that you can log in again in the future and your settings are not lost, we will first create a user account for you together.',
  welcomeTextDemoUserSetup3: 'Click "Continue" when you are ready.',
  userFormTitle: 'Create User',
  businessEmailLabel: 'Business Email',
  submitUserButton: 'Create User',
  confirmEmailTitle: 'Confirm Email',
  confirmEmailText: 'Thank you for your information.',
  confirmEmailText2:
    'We have sent an email to your email address <b>{{email}}</b>.',
  confirmEmailText3:
    'Please click on the link in the email to set your password.',
  confirmEmailText4:
    'This window will automatically close once the setup of your user account is completed.',
  checkYourData: 'Please check your information',
  demoEmailExistsAlreadyError:
    'A user with the email address "{{email}}" already exists. To log in with this user, select "Cancel" to go to the login page. If you no longer know your password, you can enter your email address there and then use the "Forgot Password" function.',
  invalidEmail: 'Please enter a valid email address',
  demoDurationHint:
    'This demo is valid until {{validUntil}} ({{remainingDays}} days remaining)',
  demoExpiredTodayHint: 'This demo expired today ({{expiredAt}})',
  demoExpiredHint: 'This demo expired on {{expiredAt}} ({{daysAgo}} days ago)',
  extendDurationTitle: 'Extend Demo Duration',
  extendDurationDescription: 'Select a new expiration date for this demo.',
  newValidUntilDate: 'New expiration date',
  disableDemo: 'Disable Demo',
  deleteDemo: 'Delete Demo',
  switchToLive: 'Switch to Live',
  disableDemoTitle: 'Disable Demo?',
  disableDemoMessage: 'This will set the expiration date to today.',
  deleteDemoTitle: 'Delete Demo?',
  deleteDemoMessage:
    'Do you really want to delete the demo {{name}}? This will permanently delete all demo data.',
  customerName: 'Customer Name',
  switchToLiveTitle: 'Switch to Live Customer?',
  switchToLiveMessage:
    'This will convert this demo customer into a live customer.',
  generatedDataWillBeDeleted: 'All generated data will be deleted.',
  deleteOptions: 'Delete Options',
  deleteManuallyCreatedJobs: 'Delete manually created services',
  deleteManuallyCreatedPoolers: 'Delete manually created poolers',
  deleteManuallyCreatedDispos: 'Delete manually created dispatchers',
  deleteManuallyCreatedEmployments: 'Delete manually created employments',
  confirmSwitchToLiveTitle: 'Confirm Switch to Live Customer',
  confirmSwitchToLiveMessage:
    'Do you really want to make {{name}} a live customer? This action cannot be undone.',
  durationExtended: 'Demo duration successfully extended',
  demoDisabled: 'Demo successfully disabled',
  demoDeleted: 'Demo successfully deleted',
  switchedToLive: 'Successfully switched to live customer',
  errorExtendingDuration: 'Error extending demo duration',
  errorDisablingDemo: 'Error disabling demo',
  errorDeletingDemo: 'Error deleting demo',
  errorSwitchingToLive: 'Error switching to live customer',
  poolerTypeBookingWarningDefaultMessage:
    'Are you sure you want to book the employee of the pooler type {{poolerType}} for the service?',
  bookingWarningEnabled: 'Enable booking warning',
  bookingWarningMessage: 'Booking warning',
  bookingWarningTitle: 'Booking warning for {{firstName}} {{lastName}}',
  enableTimeTrackingSigninProcess: 'Enable signature for time tracking',
  autoAddTimeTrackingHours:
    'Default hours automatically submit after X hours if not entered by pooler',
  requestSignature: 'Request signature',
  requestSignatureIntro:
    'Please go to the person responsible for the service and hand over your device for the digital signing of your hours.',
  requestSignatureIntroDetails:
    'If you do not have the opportunity to physically hand over your device, your hours will be automatically sent by email after the deadline.',
  handOverDevice: 'Please hand over your device now',
  checkHoursDescription:
    'Please check and correct the working hours of {{name}} if necessary.',
  signHours: 'Sign hours',
  signHoursDescription:
    'Please enter your name and confirm the hours with your signature.',
  signHere: 'Sign here',
  clear: 'Clear',
  signatureRequired: 'Signature is required',
  timeTrackingConfirmation: 'Thank you',
  timeTrackingConfirmationDescription:
    'We have received the approval of the hours. You can now <b>return</b> the device.',
  sign: 'Sign',
  timeRemaining: 'remaining',
  timerExpired: 'Deadline expired',
  timerExpiredDescription:
    'The deadline has expired. Your hours have been sent by email for approval.',
  bookingWebHookTitle: 'Booking Webhook',
  bookingWebHookDescription:
    'The booking webhook is used when employees in the Job Pool are booked or canceled.',
  bookingWebHookUrl: 'Webhook URL',
  bookingWebHookApiKey: 'API Key',
  bookingWebHookApiKeyCurrent: 'Current:',
  bookingWebHookApiKeyLeaveEmpty: 'leave empty to keep unchanged',
  carePeoplePoolerBookingFailed: 'Employee could not be booked by CarePeople',
  vokusPoolerBookingFailed: 'Employee could not be booked by Vokus',
  enablePerigonApi: 'Enable Perigon API',
  perigonTaskId: 'Perigon Task ID',
  perigonId: 'Perigon ID',
  addPerigonShiftMapping: 'Add Perigon shift mapping',
  perigonMapping: 'Perigon mappings',
  perigonMappingIncompleteAt: 'Perigon mapping incomplete since',
  perigonMappingIncomplete: 'Perigon mapping incomplete',
  showUnmappedJobs: 'Only jobs with missing Perigon mapping',
  timeTrackingEnabledByOwnerTooltip: 'Enabled by the organization',
  timeTrackingDefaultPause: 'Standard pause in hours (if not set on shift)',
  timeTrackingDefaultPauseByDepartment: 'Standard pause per shift',
  default: 'Default',
  sharedPoolAllowUndecided:
    'Show unknown availability in Shared Pool as option',
  disableTimetrackingForNewOrganisationsByDefault:
    'Time tracking for new organizations disabled by default',
  instructions: 'Instructions',
  noEmploymentsFound: 'No employments found',
  showOnlyUnapprovedHours: 'Show only unapproved hours',
  allowExternalPoolers: 'Consider external poolers',
  disableDispoFilterSave: 'Disable dispo filter save',
  requiredPause: 'Required pause in hours between two services',
  wardManagement: 'Ward management',
  conditionalTransfers: 'Conditional transfers',
  transfersConfirmed: 'Transfers confirmed',
  transferConfirmationPerson: 'Transfer confirmation person',
  enableDescription: 'Enable description',
  statusAfterCancel: {
    AVAILABLE: 'Available',
    UNAVAILABLE: 'Unavailable',
    WORKING: 'Busy',
    UNKNOWN: 'Unknown',
  },
  requestersCanAccessReports: 'Requesters can access reports',
  requestersCanAccessJobOverviewReport:
    'Requesters can access job overview report',
  perigonBearerToken: 'Perigon API Key',
  perigonClientId: 'Perigon Client ID',
  addPerigonTaskMapping: 'Add Perigon task mapping',
  loadingEmployments: 'Loading employments',
  perigonMappingIncompleteDescription:
    'The Perigon mapping is incomplete. Please check the Perigon mapping and correct it.',
  archiveAtType: 'Archive at',
  archiveAtTypeEnum: {
    START_OF_JOB: 'Start of job',
    END_OF_JOB: 'End of job',
  },
  archiveAtOffset: 'Archive at offset in minutes',
  confirmSaveCustomerFlags:
    'Are you sure you want to save the admin settings, this can influence already recorded services?',
  archiveAtOffsetDescriptionStartOfJob:
    'Example: Service starting at 7:00 will be archived at {{timeStamp}}.',
  archiveAtOffsetDescriptionEndOfJob:
    'Example: Service ending at 16:00 will be archived at {{timeStamp}}.',
  timeTrackingSettings: 'Time Tracking Settings',
  reject: 'Reject',
  elevenHourWarning:
    'The rest period of 11 hours is not guaranteed. Please check the rest time.',
  sevenDayWarning:
    'The rest period of 83 hours after 7 days is not guaranteed. Please check the rest time.',
  potentialSevenDayWarningWithInfraction:
    'The rest period of 83 hours after 7 days cannot be guaranteed if this service is booked. Please check the rest time.',
  potentialSevenDayWarning:
    'Booking this shift will result in a 7 days in a row shift.',
  reportEnabledInOverview: 'Show report in overview',
  adminReportsAllDisabledWarning:
    'All reports are hidden. Users will no longer see any downloads in the reports overview.',
  reportsEnum: {
    JOBS_FOR_INVOICE: 'Jobs for Invoice',
    CURRENTLY_ACTIVE_EMPLOYMENTS: 'Currently Active Employments',
    EXTERNAL_CANCELLATIONS: 'External Staff Cancellation Timestamp',
    ACTIVITY: 'Inactivity',
    TIME_TRACKING: 'Timesheet',
    SHIFTS_PLANNING: 'Shift Planning',
    JOB_OVERVIEW: 'Job Overview',
    DISPONENT_OVERVIEW: 'Dispatcher Overview',
    REQUESTER_OVERVIEW: 'Requester Overview',
    POOLER_OVERVIEW: 'Pooler Overview',
    AVAILABLE_USER_JOB_PLANNING: 'Staff Planning',
    POOLER_REACTION_TIME: 'Employee Reaction Time',
    SMS_USAGE: 'SMS Usage',
    USER_AVAILABILITY: 'User Availability',
    ARCHIVED_JOBS: 'Archived Jobs and Booked Employees',
    TRANSFER: 'Transfer Report',
    AVAILABILITY_UPDATES: 'Availability Adjustments',
    PLANNING_MATRIX: 'Planning Matrix',
    HOURS_BY_DEPARTMENT: 'Hours by Department',
    CUSTOMER_CONNECTIONS: 'Connected Customers',
  },
  saveNote: 'Save Note',
  searchType: 'Search for',
  all_alternative: 'All',
  times: 'Times',
  enterHours: 'Enter hours',
  enterHoursDescription: 'Please record your working hours for this day.',
  inviteeInternalId: 'Employee internal ID',
};
